var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container flex-line align-start m-theme",class:{[_vm.theme_class]:true,
'client-mobile':_vm.mobile},staticStyle:{"align-items":"stretch"}},[(!_vm.mobile)?_c('app-bar'):_vm._e(),_c('div',{staticStyle:{"height":"100%","width":"100%","position":"relative","overflow":"hidden"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{attrs:{"id":"rootView"}})],1)],1),_c('AiBot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }